import template from './submitSuccess.html';
import controller from './submitSuccess.controller';

let submitSuccessComponent = {
  restrict: 'E',
  bindings: {
    requestSuccessMessage: '@',
    addAnotherMessage: '@',
    additionalData: '=',
    isRequestCompleted: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default submitSuccessComponent;



// WEBPACK FOOTER //
// ./app/components/submitSuccess/submitSuccess.component.js